module.exports = __webpack_public_path__ + "img/whish_v2-removebg-preview.ce59d88c.png";